module.exports = __webpack_public_path__ + "img/flag.69deb1ef.png";